/* global axios */
import ApiClient from './ApiClient';

// Tipos que o servidor esconde de quem não os declara (#1750): a menção do chat interno só chega
// ao celular com o opt-in feito no app; a web declara e vê sempre. Ponto único — todo pedido que
// lista, conta ou marca em lote passa por aqui.
export const WEB_NOTIFICATION_INCLUDES = ['internal_chat_mention'];

class NotificationsAPI extends ApiClient {
  constructor() {
    super('notifications', { accountScoped: true });
  }

  get({ page, status, type, sortOrder }) {
    const includesFilter = [status, type, ...WEB_NOTIFICATION_INCLUDES].filter(
      value => !!value
    );

    return axios.get(this.url, {
      params: {
        page,
        sort_order: sortOrder,
        includes: includesFilter,
      },
    });
  }

  getNotifications(contactId) {
    return axios.get(`${this.url}/${contactId}/notifications`);
  }

  getUnreadCount() {
    return axios.get(`${this.url}/unread_count`, {
      params: { includes: WEB_NOTIFICATION_INCLUDES },
    });
  }

  summary() {
    return axios.get(`${this.url}/summary`);
  }

  read(primaryActorType, primaryActorId) {
    return axios.post(`${this.url}/read_all`, {
      primary_actor_type: primaryActorType,
      primary_actor_id: primaryActorId,
      // Actor fora da lista branca cai no "marcar tudo" do servidor.
      includes: WEB_NOTIFICATION_INCLUDES,
    });
  }

  unRead(id) {
    return axios.post(`${this.url}/${id}/unread`);
  }

  readAll() {
    return axios.post(`${this.url}/read_all`, {
      includes: WEB_NOTIFICATION_INCLUDES,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  deleteAll({ type = 'all' }) {
    return axios.post(`${this.url}/destroy_all`, {
      type,
    });
  }

  snooze({ id, snoozedUntil = null }) {
    return axios.post(`${this.url}/${id}/snooze`, {
      snoozed_until: snoozedUntil,
    });
  }
}

export default new NotificationsAPI();
